import { useDataCatalog } from "@/composable/data-catalog";
import { OverpressureDataType } from "@soft-db/data-formatter";
import { FieldFactory } from "@soft-db/form";
import { SoftSelect } from "@soft-db/ui";
import { PropType, defineComponent } from "vue";
import * as z from "zod";
import { QueryDataConfigForm } from "./QueryDataConfig";

export default defineComponent({
	name: "OverpressureDataConfigSettings",
	props: {
		useField: {
			type: Function as PropType<FieldFactory<QueryDataConfigForm>>,
			required: true,
		},
	},
	setup(props) {
		const { t } = useI18n();
		const data = props.useField("$dataConfig.data", { schema: z.nativeEnum(OverpressureDataType) });

		const { generateMenuEntries, Overpressure } = useDataCatalog();
		const dataTypes = generateMenuEntries(Overpressure);

		return () => (
			<SoftSelect
				class="grow"
				label={t("common.dataType")}
				items={dataTypes}
				itemText="name"
				itemValue="value"
				required
				{...data.attrs}
			/>
		);
	},
});
